import React from "react";
import { MenuItem, Button, ListItemIcon, ListItemText, MenuList, Divider, Menu } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UploadDoc from "./upload-doc";
import { styled } from "@mui/material/styles";
import addfolder from "../assets/images/create-folder.png";
import uploadfile from "../assets/images/uploadfile.png";
import AddBrain from "./add-brain";
export default function UploadType(props) {
  //this below function for add brain   popup start//
  const [openuploaddoc, setOpenuploaddoc] = React.useState(false);
  const activeuploaddoc = () => setOpenuploaddoc(true);
  const handleCloseuploaddoc = () => setOpenuploaddoc(false);
  //this below function for add brain   popup end//

  //this below function for add folder   popup start//
  const [openaddfolder, setOpenaddfolder] = React.useState(false);
  const activeaddfolder = () => setOpenaddfolder(true);
  const handleCloseaddfolder = () => setOpenaddfolder(false);
  //this below function for add brain   popup end//

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: "100%",
  });
  const handleFolderUpload = (event) => {
    const files = event.target.files;
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        style={{ textTransform: "capitalize" }}
        component="label"
        variant="outlined"
        aria-controls={props.open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={props.open ? "true" : undefined}
        onClick={handleClick}
        startIcon={<CloudUploadIcon />}
      >
        {/* Upload Type */}
        Upload File / Folder
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuList sx={{ width: 320, maxWidth: "100%" }}>
          <MenuItem
            onClick={() => {
              activeaddfolder();
              handleClose();
            }}
          >
            <ListItemIcon className="foldercolor">
              {/* <CreateNewFolderIcon  /> */}
              <img src={addfolder} alt="" height={25} />
            </ListItemIcon>
            <ListItemText> New Folder</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              activeuploaddoc();
              handleClose();
            }}
            disabled={props.brainList.length === 0}
          >
            <ListItemIcon>
              {/* <UploadFileIcon   /> */}
              <img src={uploadfile} alt="" height={25} />
            </ListItemIcon>
            <ListItemText> File Upload</ListItemText>
          </MenuItem>
          {/* <MenuItem>
            <ListItemIcon>
              <img src={uploadfolder} alt="" height={25} />
            </ListItemIcon>
            <ListItemText tabIndex={-1} role={undefined}>
              {" "}
              Folder Upload <VisuallyHiddenInput type="file" multiple directory webkitdirectory onChange={handleFolderUpload} />
            </ListItemText>
          </MenuItem> */}
        </MenuList>
      </Menu>

      <UploadDoc
        openuploaddoc={openuploaddoc}
        handleCloseuploaddoc={handleCloseuploaddoc}
        brainList={props.brainList}
        getKnowledge={props.getKnowledge}
        selectedBrain={props.selectedBrain}
        setSelectedbrain={props.setSelectedbrain}
      />

      <AddBrain
        brainList={props.brainList}
        setBrainList={props.setBrainList}
        openaddbrain={openaddfolder}
        handleCloseaddbrain={handleCloseaddfolder}
        getbrains={props.getbrains}
        selectedBrain={props.selectedBrain}
        setSelectedbrain={props.setSelectedbrain}
      />
    </>
  );
}
